<template>
  <div class="wisdomCity">
    <div class="module">
      <ul class="ul">
        <li class="li" v-for="(item, index) in moduleList" :key="index" @click="handleCaseClick">
          <div class="img">
            <img :src="item.img" alt="" />
          </div>
          <div class="name">
            {{ item.name }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { enableCasePreview, getToken } from '@/utils/auth';

export default {
  name: 'wisdomCity',
  data() {
    return {
      moduleList: [
        {
          img: require('./img/la.jpg'),
          name: '安徽六安'
        },
        {
          img: require('./img/aj.png'),
          name: '安吉县大数据中心'
        },
        {
          img: require('./img/dq.png'),
          name: '德清县大数据中心'
        },
        {
          img: require('./img/gx.jpg'),
          name: '西安高新区'
        },
        {
          img: require('./img/cloud.png'),
          name: '智慧大云'
        }
        // {
        //   img: require('./img/矩形@2x.png'),
        //   name: '五峰'
        // }
      ]
    };
  },
  methods: {
    handleCaseClick() {
      if (getToken()) {
        enableCasePreview();
        this.$emit('show-success');
        return;
      }
      this.$router.push('/login?redirect=%2Fcase&casePreview=1');
    }
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
@import url('~@/icons/pingfang/font.css');
.wisdomCity {
  .module {
    width: 100%;
    height: 846px;
    background: #ffffff;
    border: 1px solid #979797;
    margin: 0 auto;
    .ul {
      display: flex;
      flex-flow: wrap;
      justify-content: space-evenly;
      .li {
        margin-top: 144px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        .img {
          img {
            width: 100px;
            height: 100px;
          }
        }
        .name {
          text-align: center;
          width: 300px;
          height: 33px;
          font-size: 24px;
          font-family: 'PingFang';
          color: #000000;
          line-height: 33px;
          margin-top: 52px;
        }
      }
    }
  }
}
</style>
